import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from './tooltip/Tooltip';

const RequiredStar: FC = () => {
  const { t } = useTranslation('common');

  return (
    <Tooltip text={t('required-field')}>
      {(tooltip) => (
        <span {...tooltip}>
          <svg className="mr-1 mb-1 inline-block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" rx="4" />
            <path
              className="text-semantic-warning"
              d="M10.692 5.78L11.268 6.82L9.044 7.748L11.284 8.66L10.676 9.732L8.74 8.324L8.996 10.74H7.796L8.036 8.324L6.1 9.748L5.476 8.66L7.7 7.732L5.476 6.836L6.068 5.764L8.052 7.188L7.796 4.756H9.012L8.74 7.188L10.692 5.78Z"
              fill="currentColor"
            />
          </svg>
        </span>
      )}
    </Tooltip>
  );
};

export default RequiredStar;
